import angular from 'angular';

import {
  vmSharedModelService
} from 'app/services';
import service from './vm.navigation.service';

require('ng-smooth-scroll');

const ngSmoothScroll = 'smoothScroll';


export default angular.module('app.components.advisory.vendorManagement.VendorManagementNavigationService', [
  ngSmoothScroll,
  vmSharedModelService,
])
  .service('vendorManagementNavigationService', service)
  .name;

console.log('app.components.advisory.vendorManagement.VendorManagementNavigationService created');
